module.exports = __webpack_public_path__ + "img/arrow_share.1dcf6a38.svg";